import React from "react";
import "../../assets/css/PrakInfo.css";

function PrakInfo(props) {
  return <div className="prak">hello</div>;
}

export default PrakInfo;
